import React, { useEffect } from "react";
import CompanyDetails from "../../../Components/GNA/CompanyDetails/CompanyDetails";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  fetchCompanyById,
  fetchConsumersCompanyId,
  fetchDiscomssCompanyId,
  fetchFullTrader,
  fetchGeneratorsCompanyId,
} from "../../../Redux/Slices/gnaAdminSlice";

const Page_Admin_company = () => {
  let location = useLocation();
  const id = location?.search?.split("=")[1];
  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) return;
    dispatch(fetchCompanyById(id));
    dispatch(fetchConsumersCompanyId(id));
    dispatch(fetchGeneratorsCompanyId(id));
    dispatch(fetchDiscomssCompanyId(id));
    dispatch(fetchFullTrader());
  }, [dispatch, id]);

  return <CompanyDetails />;
};

export default Page_Admin_company;
